module.exports = __webpack_public_path__ + "img/feature_magic.7e84a103.png";